export const lavisCurry = {
  id: "lavisCurry",
  link: "/#/recipes/recipes/lavisCurry",
  name: "Lavis Curry",
  cuisine: "Alethi",
  summary: "Shrimp and hominy curry",
  inspiration: "Thai curry",
  quantity: "4 servings",
  time: "45 minutes",
  // TODO: make this again with honey to turn it into a women's food dish
  notes:
    "It's fairly normal on earth to eat curry with rice. So I've paired the other curries in this collection with rice. But in the books, they don't always eat curry with tallew (similar to rice). They eat it with lavis (similar to corn) as well. So I decided I needed to try serving a curry with hominy. It ended up working best to cook the hominy into curry. I prepared this neither particularly spicy nor sweet, to help differentiate from the other dishes in the collection. To make a women's food version of this, simply add a tablespoon of honey along with the coconut milk. To make a men's food version, use a spicer curry paste or add a tablespoon or two of gochugaru.",
  quotes:
    "He'd brought her food - warm curry and lavis, from the smell of it. (Rhythm of War ch 24)",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/lavis-curry-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "onion",
          display: "1 onion"
        },
        {
          item: "garlicClove",
          display: "4 cloves garlic"
        },
        {
          item: "ginger",
          display: "2 inches ginger"
        },
        {
          item: "bellPepper",
          display: "2 bell peppers, any color but green"
        },
        {
          item: "coconut",
          display: "1 tbsp coconut oil"
        },
        {
          item: "shrimp",
          display: "1 lb uncooked shrimp without shells"
        },
        {
          item: "curryPaste",
          display: "2 tbsp mild curry paste"
        },
        {
          item: "coconut",
          display: "1 14 oz can coconut milk"
        },
        {
          item: "hominy",
          display: "1 25 oz can hominy"
        },
        {
          item: "salt",
          display: "1 tsp salt"
        }
      ]
    }
  ],
  steps: [
    "Peel and dice the onion. Peel and mince the garlic. Peel and grate the ginger. Chop the bell peppers into bite sized pieces.",
    "Heat the coconut oil in a large pan over medium high heat. Add the onions, garlic and ginger and cook and stir 5 minutes until tender.",
    "Add the shrimp to the pan. Cook and stir occasionally until pink and cooked through, about 5 minutes. Remove pan from heat and remove shrimp from pan, leaving the onion mixture in the pan.",
    "Add 2 tbsp curry paste to the pan. Cook and stir over medium high heat until well combined, about 2 minutes. Add the coconut milk. Blend everything well with an immersion blender.",
    "Drain the hominy. Add the hominy to the pan along with the chopped bell peppers and salt. Cover and simmer until peppers are tender, about 10 minutes.",
    "Add the shrimp to the pan and heat through. Serve."
  ]
}
